import { Component, Input } from '@angular/core';

@Component({
  selector: 'ush-ui-attribute',
  template: `
    <span [attr.data-translate]="'showtime.attribute.' + attribute"
      >{{ 'showtime.attribute.' + attribute | translate: { placeholder: attribute } }}<span class="comma">,</span></span
    >
  `,
  styleUrls: ['./ui-attribute.component.scss']
})
export class UiAttributeComponent {
  @Input() attribute: string;
}
